import { useContext } from 'react';

import { UploadCenterContext, type UploadCenterContextValue } from './UploadCenterContext';

/**
 * 访问全局上传中心。
 *
 * 必须在 `UploadCenterProvider` 内使用，否则抛错（避免组件偷偷掉单）。
 */
export function useUploadCenter(): UploadCenterContextValue {
  const ctx = useContext(UploadCenterContext);
  if (!ctx) {
    throw new Error('useUploadCenter 必须在 <UploadCenterProvider> 内使用');
  }
  return ctx;
}
